import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ShutdownDeviceBaseDirective } from './shutdown-device.base.directive';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ml-mdm-shutdown-device',
  templateUrl: './shutdown-device.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class ShutdownDeviceComponent extends ShutdownDeviceBaseDirective {}
